(ns minorodata.components.layout.core
  (:require [minorodata.components.sidebar.core :as c.sidebar]

            [reagent.core :as reagent]
            [ui.utils :refer [clsx]]))

(defn main [{:keys [sidebar sidebarEnabled ai route baseClass container]
    :or {sidebarEnabled true}}]
  (let [this     (reagent/current-component)
        children (reagent/children this)]
    [:div {:class ["flex min-h-screen flex-row" baseClass]}

     (when sidebar
       [c.sidebar/sidebar {:route route
                           :sidebar-enabled sidebarEnabled}])

     [:main {:class "grow shrink max-w-full overflow-hidden"}
      (into
       [:div {:key   (str container)
              :class [(clsx "min-h-screen w-full h-full"
                            "print:mx-0! print:min-w-0 print:max-w-none" ;; Used in data docs
                            (when (:singleScreen container)
                              "overflow-hidden h-screen"))]
              :style (when ai {"--spacing-kai" "100px"})}]
       children)]]))
